import { useTranslation } from 'react-i18next';
import { Card, Tabs } from '@/components/ui';
import { PageContainer } from '@/layouts/PageContainer';
import { useUrlState } from '@/lib/url-state';
import { OperationalRecords } from './OperationalRecords';
import styles from './parity.module.css';
type SchemeTab = 'madani' | 'peka_b40' | 'perkeso_case';
export function GovernmentSchemesPage() {
  const { t } = useTranslation();
  const [tab, setTab] = useUrlState<SchemeTab>('tab', 'madani', [
    'madani',
    'peka_b40',
    'perkeso_case',
  ]);
  const tabs = (
    <Tabs
      variant="bar"
      label={t('government.title')}
      value={tab}
      onChange={setTab}
      items={(['madani', 'peka_b40', 'perkeso_case'] as SchemeTab[]).map(
        (value) => ({ value, label: t(`government.${value}`) }),
      )}
    />
  );
  return tab === 'madani' ? (
    <PageContainer>
      {tabs}
      <Card title={t('government.madani')}>
        <p className={styles.notice}>{t('government.madaniBody')}</p>
      </Card>
    </PageContainer>
  ) : (
    <OperationalRecords
      key={tab}
      title={t('government.title')}
      kinds={[tab]}
      before={tabs}
    />
  );
}
